import styled from "styled-components";
import { H2, H3, P } from "@/lib/styles";
import { debug } from "@/lib/styles/helpers";

export const Container = styled.div`
  color: ${({ theme }) => theme.colors.middleGrey};
  padding-bottom: 4.5rem;
  ${({ theme }) => theme.mediaQueries.tablet} {
    padding-bottom: 5.5rem;
  }
`;

export const Marker = styled.span`
  display: none;
  ${({ theme }) => theme.mediaQueries.tablet} {
    display: block;
  }
`;

export const Title = styled(H3)`
  margin-bottom: 0.5rem;

  font-weight: 400;

  ${({ theme }) => theme.mediaQueries.tablet} {
    position: relative;
    ${Marker} {
      position: absolute;
      left: -1.5rem;
      transform: translateX(-100%);
    }
  }
`;

export const Body = styled(P)``;

export const Indicator = styled(H2)`
  font-style: normal;
  font-weight: 400;
  ${({ theme }) => theme.mediaQueries.tablet} {
    display: none;
  }
`;
